import './MoreButtonArticle.scss';

const MoreButtonArticle = () => {

    const scrollToSection = () => {
        const section = document.getElementById("need__section");
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <div className="more__button__article" onClick={scrollToSection}>
            <svg
                className="swipe-line"
                width="5"
                height="100"
                viewBox="0 0 3 87"
                fill="none"
                stroke="#fff"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0.749996 0L0.749996 87"
                    stroke="white"
                    strokeWidth="1"
                />
            </svg>
        </div>
    );
};

export default MoreButtonArticle;